import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { ProductsPage } from 'src/modules/catalog/components/pages/products.page';
import { productsSearchSchema } from 'src/modules/catalog/schemas/products-search.schema';

export const Route = createFileRoute('/catalog/products')({
  component: CatalogProductsComponent,
  validateSearch: (search) => productsSearchSchema.parse(search),
});

function CatalogProductsComponent() {
  return (
    <AuthenticateRoute>
      <ProductsPage />
    </AuthenticateRoute>
  );
}
